// Catalogue of every building in Zombie Idle Tycoon.
// Order matters — buildings unlock left-to-right based on `unlockGold` so
// the player has a clear progression target.

// Sprite filenames map 1:1 to the auto-cropped PNGs in
// /public/games/tycoon/sprites/ (see /app/scripts/crop_tycoon_sprites.py).
const SPRITE_DIR = "/games/tycoon/sprites";

export const BUILDINGS = [
  // baseIncome = gold/sec at level 1.  baseCost = gold to first-build.
  // costMult = how much the upgrade cost grows per level.
  // unlockGold = lifetime gold required before this building is available.
  { id: "zombie-hut",        name: "Zombie Hut",        sprite: `${SPRITE_DIR}/zombie-hut.png`,        baseIncome: 1,      baseCost: 10,         costMult: 1.18, unlockGold: 0 },
  { id: "laboratory",        name: "Laboratory",        sprite: `${SPRITE_DIR}/laboratory.png`,        baseIncome: 6,      baseCost: 120,        costMult: 1.20, unlockGold: 100 },
  { id: "zombie-mine",       name: "Zombie Mine",       sprite: `${SPRITE_DIR}/zombie-mine.png`,       baseIncome: 30,     baseCost: 1_400,      costMult: 1.21, unlockGold: 1_200 },
  { id: "power-plant",       name: "Power Plant",       sprite: `${SPRITE_DIR}/power-plant.png`,       baseIncome: 150,    baseCost: 14_000,     costMult: 1.22, unlockGold: 12_000 },
  { id: "research-center",   name: "Research Center",   sprite: `${SPRITE_DIR}/research-center.png`,   baseIncome: 750,    baseCost: 140_000,    costMult: 1.22, unlockGold: 120_000 },
  { id: "upgrade-workshop",  name: "Upgrade Workshop",  sprite: `${SPRITE_DIR}/upgrade-workshop.png`,  baseIncome: 3_800,  baseCost: 1_400_000,  costMult: 1.23, unlockGold: 1_200_000 },
  { id: "zombie-barracks",   name: "Zombie Barracks",   sprite: `${SPRITE_DIR}/zombie-barracks.png`,   baseIncome: 19_000, baseCost: 14_000_000, costMult: 1.24, unlockGold: 12_000_000 },
  { id: "training-pit",      name: "Training Pit",      sprite: `${SPRITE_DIR}/training-pit.png`,      baseIncome: 95_000, baseCost: 1.4e8,      costMult: 1.24, unlockGold: 1.2e8 },
  { id: "zombie-farm",       name: "Zombie Farm",       sprite: `${SPRITE_DIR}/zombie-farm.png`,       baseIncome: 4.5e5,  baseCost: 1.4e9,      costMult: 1.25, unlockGold: 1.2e9 },
  { id: "toxic-reactor",     name: "Toxic Reactor",     sprite: `${SPRITE_DIR}/toxic-reactor.png`,     baseIncome: 2.2e6,  baseCost: 1.4e10,     costMult: 1.25, unlockGold: 1.2e10 },
  { id: "warehouse",         name: "Warehouse",         sprite: `${SPRITE_DIR}/warehouse.png`,         baseIncome: 1.1e7,  baseCost: 1.4e11,     costMult: 1.26, unlockGold: 1.2e11 },
  { id: "command-center",    name: "Command Center",    sprite: `${SPRITE_DIR}/command-center.png`,    baseIncome: 5e7,    baseCost: 1.4e12,     costMult: 1.26, unlockGold: 1.2e12 },
  { id: "portal-gate",       name: "Portal Gate",       sprite: `${SPRITE_DIR}/portal-gate.png`,       baseIncome: 2.4e8,  baseCost: 1.4e13,     costMult: 1.27, unlockGold: 1.2e13 },
  { id: "apocalypse-core",   name: "Apocalypse Core",   sprite: `${SPRITE_DIR}/apocalypse-core.png`,   baseIncome: 1.2e9,  baseCost: 1.4e14,     costMult: 1.28, unlockGold: 1.2e14 },
];

export const BUILDING_BY_ID = Object.fromEntries(BUILDINGS.map((b) => [b.id, b]));

// Each building level multiplies its base income by INCOME_MULT.
export const INCOME_MULT = 1.10;

// Tap bonus: clicking on a built building grants an instant boost equal to
// TAP_BONUS_SEC × total income (i.e. "skip ahead this many seconds").
export const TAP_BONUS_SEC = 1.5;

// Gold milestones that pay arcade coins.  Each is awarded ONCE per account.
// Hitting larger thresholds while signed-in deposits arcade coins.
export const COIN_MILESTONES = [
  { gold: 1_000,        coins: 25  },
  { gold: 100_000,      coins: 50  },
  { gold: 10_000_000,   coins: 100 },
  { gold: 1_000_000_000, coins: 200 },
  { gold: 1e12,         coins: 400 },
];

// New-building rewards — paid once per building first-build.
export const BUILD_FIRST_COINS = 20;
